import $ from "jquery";

window.$ = window.jQuery = $;

// ⚠️ All legacy scripts must be loaded *after* jQuery is global
(async () => {
  await import("bootstrap");
  await import("../lib_single/api_request.js");
  await import("../../lib/bootstrap-dropdownhover.min.js");

  const anchors = document.querySelectorAll(".scrollTo");

  for (const anchor of anchors) { // Скролл к якорю, без jQuery
    anchor.addEventListener("click", function(e) {
      e.preventDefault();

      const blockSelector = anchor.getAttribute("data-scroll");

      document.querySelector(blockSelector).scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });
  }

  $(document).ready(function() {
    $(document).on("click", ".showAllAutorPosts", function(e) {
      const target = $(e.target);
      target.hide(500);
      $(".author-post").removeClass("hidden");
      return false;
    });
    $(document).on("click", ".navbar-toggle", function(e) {
      $("#navbar-header").removeClass("d-none");
    });
    $(document).on("click", ".bs-navbar-collapse__toggle", function(e) {
      $("#navbar-header").addClass("d-none");
      setTimeout(() => {
        $("#navbar-header").removeClass("in");
      }, 400);
    });
  });
})();

